import isEmpty from 'lodash/isEmpty';

import { WidgetTranslatableData } from '../types';

/** Parse the widgets translatable values to html string <article> for each widget */
export const parseWidgetsTranslatableDataToTranslatableString = (data: WidgetTranslatableData) => {
    const translatableValues = [];
    for (const [uuid, widget] of Object.entries(data)) {
        const { title, body, footer, type } = widget;
        const elements = [
            title.shouldAutoTranslate &&
                !isEmpty(title.valueToTranslate) &&
                `<header data-field="title">${title.valueToTranslate}</header>`,
            body.shouldAutoTranslate &&
                !isEmpty(body.valueToTranslate) &&
                `<main data-field="body">${body.valueToTranslate}</main>`,
            footer.shouldAutoTranslate &&
                !isEmpty(footer.valueToTranslate) &&
                `<footer data-field="footer">${footer.valueToTranslate}</footer>`,
        ].filter(Boolean);

        if (elements.length > 0) {
            translatableValues.push(
                `<article data-widget-id="${uuid}" data-widget-type="${type}">${elements.join('')}</article>`,
            );
        }
    }

    return translatableValues;
};
